import React from "react";

export const STEADYMD_ONLY_PAGE_ERROR_MESSAGE =
  "Oops! Your Noom Med program does not have access to this page.";

export const SteadyMdOnlyPageError: React.FC = () => {
  return (
    <div
      data-cy="steadymd-only-page-error"
      style={{
        backgroundColor: "white",
        border: "1px solid #d3c9b4",
        fontFamily: "Untitled sans, sans-serif",
        fontSize: "20pt",
        fontWeight: 200,
        margin: "10px",
        padding: "10px",
        textAlign: "center",
      }}
    >
      {STEADYMD_ONLY_PAGE_ERROR_MESSAGE}
    </div>
  );
};
